import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconEqualsMore(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M5 17C4.44772 17 4 17.4477 4 18C4 18.5523 4.44772 19 5 19H19C19.5523 19 20 18.5523 20 18C20 17.4477 19.5523 17 19 17H5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7071 12.7071C19.0976 12.3166 19.0976 11.6834 18.7071 11.2929L12.7071 5.29289C12.3166 4.90237 11.6834 4.90237 11.2929 5.29289L5.29289 11.2929C4.90237 11.6834 4.90237 12.3166 5.29289 12.7071C5.68342 13.0976 6.31658 13.0976 6.70711 12.7071L12 7.41421L17.2929 12.7071C17.6834 13.0976 18.3166 13.0976 18.7071 12.7071Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
